// TODO: This file seems like a dumping ground of unrelated functions. This should
// really be broken up and grouped into cohesive libraries, or at the very least renamed
// to something sensible.

export const isAutoBlocked = (node) => {
  const attrDataAutoBlocked = node.getAttribute('data-autoblocked')
  return parseInt(attrDataAutoBlocked, 10) === 1
}
